// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"4149ab30","839":"35ca1da2"}[chunkId] + ".chunk.js";
};